import styled from 'styled-components';
import {Row, RowW50Styles, Column} from './../../common/Layouts/Layouts';

export const OfferLoaderWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 28.5rem;
  height:19rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.noBackGround ? '' : props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};
  padding-right:${props.theme.spacing.xxlarge};
  padding-left:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.xlarge};
  margin-bottom: 2rem;
`,
);

export const offerInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;


`,
);

export const offerImageWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 19.3rem;
  top: -3.5rem;
  position: relative;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.base};
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.medium};



`,
);

export const offerImageInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  height:11.4rem;
  width:100%;
  background-color:${props.theme.colors.goBrandBlue.medium};


`,
);

export const OfferDeatilsWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  padding:${props.theme.spacing.base};
  width:100%;
  flex-direction: column;
`,
);

export const OfferLoaderContextWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width: 16.8rem;
  height:1.2rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const ValidLoaderContextWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:11rem;
  height:1.2rem;
  margin-top :${props.theme.spacing.small};

`,
);

export const AllOfferLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:11rem;
  height:1.2rem;

  position:relative;
  top:-3rem;


`,
);
